import SessionStorageKeys from '../constants/sessionStorageKeys';

export const isSessionStorageAccess = () => {
  try {
    return !!(window && window.sessionStorage);
  } catch (error) {
    return false;
  }
}

export const getXAuthToken = () => {
  return isSessionStorageAccess() && sessionStorage.getItem(SessionStorageKeys.X_AUTH_TOKEN);
};

export const setXAuthTokenInSessionStorage = (data) => {
  isSessionStorageAccess() && sessionStorage.setItem(SessionStorageKeys.X_AUTH_TOKEN, data);
};
